/*
 * Content
 *
 * Content wrapper
 */

import "./styles.scss";

import React, { Component } from "react";

/* eslint-disable react/prefer-stateless-function */
export default class RouteContent extends Component<any, any> {
	render() {
		return (
			<div id="app_content" className="RouteWrapper">
				{this.props.children}
			</div>
		);
	}
}
